import { Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

@Pipe({
  name: 'offerButtonText',
  pure: false,
  standalone: true
})
export class OfferButtonTextPipe implements PipeTransform {
  btnGrp : any;
  constructor(private readonly translocoService: TranslocoService){
    this.translocoService.selectTranslateObject('vehicles.auctionDetails.btnOfferGrp').subscribe(value =>{
      this.btnGrp = {
        viewOffer : value.btnViewOffer,
        makeOffer : value.btnMakeOffer
      };
    });
  }
  transform(value: string): string {
    switch (value) {
    case 'PENDING_SELLER_ACTION':
    case 'PENDING_BUYER_ACTION':
    case 'ON_HOLD':
    case 'VEHICLE_REMOVED':
    case 'VEHICLE_EXPIRED':
    case 'SOLD':
    case 'WON':
    case 'ACCEPTING_BIDS':
    case 'BIDDING_IN_PROGRESS':
    case 'LEADING':
    case 'NOT_SOLD':
    case 'OUTBID': {
      return this.btnGrp.viewOffer;
    }
    default: {
      return this.btnGrp.makeOffer;
    }
    }
  }
}
